import './Footer.sass';
import { useMemo } from 'react';
import { useRoutes, useArticles, useFundWarning } from '../api';
import { find } from 'lodash';
import { Link } from 'react-router-dom';
import SlideToggle from 'react-slide-toggle';
import BezierEasing from 'bezier-easing';
import { useWindowSize } from 'react-use';

const bezier = BezierEasing(0.68, 0, 0.265, 1);

const Footer = () => {
	const toTop = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	const { routes } = useRoutes();

	const landingChildren = useMemo(() => {
		return find(routes, { route: '/' })?.categoryChild || [];
	}, [routes]);

	const content = useMemo(() => {
		return find(landingChildren, (route) => {
			return route.url === '/warning' || route.route === '/warning';
		});
	}, [landingChildren]);

	const { articles } = useArticles(content?.guid || '', content?.route || '', 1, 1, '');

	const { fundWarning } = useFundWarning();

	const { width } = useWindowSize();

	const landingChildrenDesktop = useMemo(() => {
		return landingChildren.filter((child) => {
			return child.show === 1;
		});
	}, [landingChildren]);

	const landingChildrenMobile = useMemo(() => {
		return landingChildren.filter((child) => {
			return child.showm === 1;
		});
	}, [landingChildren]);

	const currentList = useMemo(() => {
		return width > 1023 ? landingChildrenDesktop : landingChildrenMobile;
	}, [width, landingChildrenDesktop, landingChildrenMobile]);

	return (
		<footer>
			<div className='Footer'>
				<div className='container'>
					<div className='to-top-wrap'>
						<div className='to-top' onClick={toTop}></div>
					</div>

					<div className='links'>
						{currentList.map((child, index) => {
							const { route, url, name, guid } = child;

							if (url === '/popup' || route === '/popup') return null;
							if (url === '/warning' || route === '/warning') return null;

							return (
								<div className='link-group' key={guid}>
									{index > 0 && <div className='separator'></div>}
									<Link to={url || route}>{name}</Link>
								</div>
							);
						})}
					</div>

					<div className='content' dangerouslySetInnerHTML={{ __html: articles[0]?.contents }}></div>
				</div>
			</div>

			<SlideToggle
				duration={300}
				easeCollapse={bezier}
				easeExpand={bezier}
				collapsed
				render={({ toggle, setCollapsibleElement, toggleState }) => {
					return (
						<div className={`footer-toggle slidetoggle ${toggleState}`}>
							<div className='fund-warning-controller' onClick={toggle}>
								<div className='text'>基金警語</div>
								<div className='icon'>
									<img className='minus' src='/assets/minus.svg' alt='' />
									<img className='plus' src='/assets/plus.svg' alt='' />
								</div>
							</div>

							<div className='toggle-target' ref={setCollapsibleElement}>
								<div className='center-wrap'>
									<div className='fund-warning' dangerouslySetInnerHTML={{ __html: fundWarning }}></div>
								</div>
							</div>
						</div>
					);
				}}
			/>
		</footer>
	);
};

export default Footer;
